import React from 'react';
import installIntegration from '../../admin/integration/installIntegration';
import useAppSelector, { useAppDispatch } from '../../app/redux/useAppSelector';
import type { ButtonProps } from '../../components/Button';
import Button from '../../components/Button';
import { PlanTier } from '../../graphql/generated/graphql';
import { UIActions } from '../../ui/uiSlice';
import PricingModalButton from '../../organization/PricingModalButton';

interface InstallIntegrationButtonProps {
  platform: string;
  isPremium: boolean;
  variant?: 'link' | 'secondary';
  size?: ButtonProps['size'];
}

const InstallIntegrationButton = ({
  platform,
  isPremium,
  variant = 'link',
  size,
}: InstallIntegrationButtonProps) => {
  const dispatch = useAppDispatch();
  const planTier = useAppSelector(
    (state) => state.session.organization.planTier,
  );

  if (
    isPremium &&
    planTier &&
    [PlanTier.Free, PlanTier.Startup].includes(planTier)
  ) {
    return (
      <PricingModalButton
        onClick={() => dispatch(UIActions.clearToasts())}
        variant={variant}
        size={size}
        feature="integrations"
      >
        <strong>Upgrade</strong>
      </PricingModalButton>
    );
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => {
        installIntegration({
          platform,
          dispatch,
          redirectUrl: document.location.href,
        });
        dispatch(UIActions.clearToasts());
      }}
    >
      <strong>Enable integration</strong>
    </Button>
  );
};

export default InstallIntegrationButton;
